import * as actionTypes from "../constants/CartActionTypes";

const initialState = {
  orderId: null,
  orderCreatedAt: null,

  cart: [],

  coupon: null,

  installments: [],

  totalPrice: 0,

  rebate: 0,

  tradingAccount: 0,

  balance: 0,

  depositUsed: 0,
  
  creditUsed: 0,

};

const cartReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case actionTypes.SET_CART:
    const { _id, items, couponCode, totalPrice, installments, createdAt, rebate, balanceUsed, tradingAccount, depositUsed, creditUsed } = payload;
    return { ...state, cart: items, orderId: _id, totalPrice: totalPrice || 0, coupon: couponCode, installments, orderCreatedAt: createdAt , rebate: rebate || 0, tradingAccount: tradingAccount, balance: balanceUsed, depositUsed, creditUsed };
  
  case actionTypes.UPDATE_CART_ITEMS:
    return { ...state, cart: [ ...payload ] };
  
  case actionTypes.RESET_CART:
    return initialState;
  
  case actionTypes.SET_COUPON:
    return { ...state, coupon: payload };
  
  case actionTypes.SET_REBATE:
    return { ...state, rebate: payload };

  case actionTypes.SET_BALANCE:
    return { ...state, tradingAccount: payload.tradingAccount, balance: payload.balance };

  case actionTypes.SET_INSTALLMENTS:
    return { ...state, installments: payload };
  
  case actionTypes.SET_TOTAL_PRICE:
    return { ...state, totalPrice: payload };

  case actionTypes.SET_DEPOSIT:
    return { ...state, depositUsed: payload };

  case actionTypes.SET_CREDIT:
    return { ...state, creditUsed: payload };

  default:
    return state;
  }
}

export default cartReducer;